<template>
    <div>
        <h3 class="left-aligned text-success"> <b> Healthy and Fresh Sadqah and Aqiqa Stock </b> </h3>
        <div class="row">
            <div class="col-md-4" v-for="(post_item,i) in spliced_posts" :key="i">
                <PostCard :landing='`sadqahs`' :post_item="post_item" @order-item="$emit('order-item',post_item)" />
            </div>
        </div>
        <a-pagination :current="current" @change="onChange"  :total="rows" />   

    </div>

</template>

<script>
import {mapGetters} from 'vuex'
import PostCard from '../components/PostCard.vue'
export default {
    components:{
        PostCard
    },
      watch:{
        posts(){
            if(this.posts.length>0) {
                this.end_index=this.per_page

            }
        }
    },
    computed:{
        ...mapGetters(['posts']),
         rows() {
              if(this.posts.length>0) {
                    let lngth_posts=this.posts[6].length
                    let temp_perpage=12
                    let dividedresult=lngth_posts/temp_perpage
                    let parsed= parseInt(dividedresult)
                    if(parsed*temp_perpage<lngth_posts) {
                        parsed++
                        let sringer=parsed.toString()+'0'
                        let parsedback=parseInt(sringer)
                        return  parsedback
                    }
                    else{
                        let sringer=parsed.toString()+'0'
                        let parsedback=parseInt(sringer)
                        return  parsedback
                    }
             }
           
        },
      spliced_posts(){
          let arr2=[]
          if(this.posts.length>0){
          arr2=this.posts[6].slice(this.start_index,this.end_index)
          return arr2
          }
          else{
              return []
          }
      }
    },
    data(){
        return{
            start_index:0,
            end_index:12,
            current: 1,
            per_page:12,
            selected_post:''

        }
    },
    methods:{
        onChange(current,pkd){
            this.end_index=this.per_page*current     
            this.current = current;
            this.start_index=(this.current-1)*this.per_page
        }
    },
    created(){
        localStorage.setItem("route","Sadqah")

    },
    mounted(){
        localStorage.setItem("route","Sadqah")
    }

}
</script>

<style>

</style>